import { useEffect, useState } from 'react'

const useDetectInstagramUA = (): { isInstagram: boolean; loading: boolean } => {
  const [loading, setLoading] = useState(true)
  const [isInstagram, setIsInstagram] = useState(false)

  useEffect(() => {
    const ua = navigator.userAgent

    if (ua.indexOf('Instagram') > -1) {
      setIsInstagram(true)
    }

    setLoading(false)
  }, [])

  return { isInstagram, loading }
}

export default useDetectInstagramUA
